//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.15.10.0 (NJsonSchema v10.6.10.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export interface ProblemDetails {
  type?: string | undefined
  title?: string | undefined
  status?: number | undefined
  detail?: string | undefined
  instance?: string | undefined
}

export interface CreateAssetCommand {
  assetName?: string | undefined
  assetId?: string | undefined
  useProjection: boolean
  projection?: string | undefined
  projectedCorner?: LatLng | undefined
  projectedOppositeCorner?: LatLng | undefined
  corner?: LatLng | undefined
  oppositeCorner?: LatLng | undefined
  legendAssetId?: string | undefined
  legend?: string | undefined
}

export interface ValueObject {}

export interface LatLng extends ValueObject {
  lat?: string | undefined
  lng?: string | undefined
}

export interface AssetDetailDto {
  id: string
  assetName?: string | undefined
  useProjection: boolean
  projection?: string | undefined
  projectedCorner?: LatLng | undefined
  projectedOppositeCorner?: LatLng | undefined
  corner?: LatLng | undefined
  oppositeCorner?: LatLng | undefined
  assetId?: string | undefined
  imageUrl?: string | undefined
  thumbnailUrl?: string | undefined
  legend?: string | undefined
  legendUrl?: string | undefined
  legendAssetId?: string | undefined
}

export interface PaginatedListOfAssetDto {
  items?: AssetDto[] | undefined
  pageIndex: number
  totalPages: number
  totalCount: number
  hasPreviousPage: boolean
  hasNextPage: boolean
}

export interface AssetDto {
  id: string
  assetName?: string | undefined
  licences?: string | undefined
}

export interface UpdateAssetCommand {
  id: string
  assetName?: string | undefined
  assetId?: string | undefined
  useProjection: boolean
  projection?: string | undefined
  projectedCorner?: LatLng | undefined
  projectedOppositeCorner?: LatLng | undefined
  corner?: LatLng | undefined
  oppositeCorner?: LatLng | undefined
  legendAssetId?: string | undefined
  legend?: string | undefined
}

export interface CreateBundleCommand {
  title?: string | undefined
}

export interface BundleDto {
  id: string
  title?: string | undefined
  profileId: string
  created: Date
  lastModified?: Date | undefined
  projectAmount: number
  comparisonAmount: number
}

export interface BundleDetailDto {
  id: string
  title?: string | undefined
  profileId: string
  projects?: ProjectDto[] | undefined
  projectComparisons?: ProjectComparisonDto[] | undefined
}

export interface ProjectDto {
  id: string
  metadataId: string
  assetThumbnailUrl?: string | undefined
  title?: string | undefined
  drawing?: string | undefined
  bundles?: BundleDto[] | undefined
  lastModified?: Date | undefined
  sharedClass?: string | undefined
}

export interface ProjectComparisonDto {
  id: string
  title?: string | undefined
  firstId: string
  firstAssetThumbnailUrl?: string | undefined
  secondId: string
  secondAssetThumbnailUrl?: string | undefined
  thirdId: string
  thirdAssetThumbnailUrl?: string | undefined
  fourthId: string
  fourthAssetThumbnailUrl?: string | undefined
  layout: ComparisonLayout
  lastModified?: Date | undefined
  bundles?: BundleDto[] | undefined
  sharedClass?: string | undefined
}

export enum ComparisonLayout {
  Vertical = 0,
  Horizontal = 1,
  VerticalRightSplit = 2,
  VerticalLeftSplit = 3,
  HorizontalTopSplit = 4,
  HorizontalBottomSplit = 5,
  FourWaySplit = 6,
  VerticalThreeWaySplit = 7
}

export interface UpdateBundleCommand {
  id: string
  title?: string | undefined
}

export interface AddContentToBundleCommand {
  id: string
  projectIds?: string[] | undefined
  comparisonIds?: string[] | undefined
}

export interface CreateChapterCommand {
  name?: string | undefined
  thumbnailAssetId?: string | undefined
  order: number
  zone: ChapterZone
  licenceIds?: string[] | undefined
}

export enum ChapterZone {
  TOP = 0,
  BOTTOM = 1
}

export interface PaginatedListOfChapterDto {
  items?: ChapterDto[] | undefined
  pageIndex: number
  totalPages: number
  totalCount: number
  hasPreviousPage: boolean
  hasNextPage: boolean
}

export interface ChapterDto {
  id: string
  name?: string | undefined
  order: number
  thumbnailUrl?: string | undefined
  zone: ChapterZone
  licences?: LicenceDto[] | undefined
}

export interface LicenceDto {
  id: string
  name?: string | undefined
  ean?: string | undefined
}

export interface RegionDto {
  id: string
  chapterId: string
  chapter?: ChapterDto | undefined
  name?: string | undefined
  licences?: LicenceDto[] | undefined
  order: number
}

export interface ThemeDto {
  id: string
  name?: string | undefined
  regionId?: string | undefined
  chapterId?: string | undefined
  order: number
}

export interface MapDto {
  id: string
  title?: string | undefined
  pageNumber: number
  pageSection?: string | undefined
  chapter?: string | undefined
  region?: string | undefined
  theme?: string | undefined
  aliasses?: string[] | undefined
  category?: string | undefined
  isDigitalOnly: boolean
  thumbnailUrl?: string | undefined
}

export interface UpdateChapterCommand {
  id: string
  name?: string | undefined
  thumbnailAssetId?: string | undefined
  order: number
  zone: ChapterZone
  licenceIds?: string[] | undefined
}

export interface PaginatedListOfLicenceDto {
  items?: LicenceDto[] | undefined
  pageIndex: number
  totalPages: number
  totalCount: number
  hasPreviousPage: boolean
  hasNextPage: boolean
}

export interface CreateLicenceCommand {
  name?: string | undefined
  ean?: string | undefined
  baseLicenceId?: string | undefined
}

export interface Exception {
  Message: string
  InnerException?: Exception | undefined
  Source?: string | undefined
  StackTrace?: string | undefined
}

export interface ValidationException extends Exception {
  errors?: { [key: string]: string[] } | undefined
}

export interface UpdateLicenceCommand {
  id: string
  name?: string | undefined
  ean?: string | undefined
}

export interface CreateLinkChapterCommand {
  name?: string | undefined
  thumbnailAssetId?: string | undefined
  url?: string | undefined
  order: number
  zone: ChapterZone
  licenceIds?: string[] | undefined
}

export interface PaginatedListOfLinkChapterDto {
  items?: LinkChapterDto[] | undefined
  pageIndex: number
  totalPages: number
  totalCount: number
  hasPreviousPage: boolean
  hasNextPage: boolean
}

export interface LinkChapterDto {
  id: string
  name?: string | undefined
  order: number
  thumbnailUrl?: string | undefined
  url?: string | undefined
  zone: ChapterZone
  licences?: LicenceDto[] | undefined
}

export interface UpdateLinkChapterCommand {
  id: string
  name?: string | undefined
  thumbnailAssetId?: string | undefined
  url?: string | undefined
  order: number
  zone: ChapterZone
  licenceIds?: string[] | undefined
}

export interface MapDetailDto {
  id: string
  title?: string | undefined
  category?: string | undefined
  pageNumber: number
  pageSection?: string | undefined
  chapter?: string | undefined
  region?: string | undefined
  theme?: string | undefined
  aliasses?: string | undefined
  imageUrl?: string | undefined
  casperId?: string | undefined
  thumbnailUrl?: string | undefined
  attachments?: AttachmentDto[] | undefined
  corner?: LatLng | undefined
  oppositeCorner?: LatLng | undefined
  dateOfMap: Date
  legendUrl?: string | undefined
  legend?: string | undefined
  projection?: string | undefined
  assetId: string
}

export interface AttachmentDto {
  id?: string | undefined
  title?: string | undefined
  description?: string | undefined
  location?: string | undefined
  pointOnMap?: LatLng | undefined
  type: AttachmentType
  order: number
  isAuthorContent: boolean
}

export enum AttachmentType {
  Note = 0,
  Image = 1,
  Video = 2
}

export interface MapSearchResult {
  page: number
  pageSize: number
  totalPages: number
  count: number
  filterGroups?: MapSearchFilterGroup[] | undefined
  items?: MapSearchDto[] | undefined
}

export interface MapSearchFilterGroup {
  name?: string | undefined
  filters?: MapSearchFilter[] | undefined
}

export interface MapSearchFilter {
  name?: string | undefined
  resultCount: number
}

export interface MapSearchDto {
  id: string
  title?: string | undefined
  aliasses?: string[] | undefined
  category?: string | undefined
  theme?: string | undefined
  chapter?: string | undefined
  region?: string | undefined
  pageNumber: number
  pageSection?: string | undefined
  isDigitalOnly: boolean
  thumbnailUrl?: string | undefined
  topoLat?: string | undefined
  topoLng?: string | undefined
  topoName?: string | undefined
  topoSuffix?: string | undefined
}

export interface MapSearchSuggestionListDto {
  suggestions?: MapSearchSuggestionDto[] | undefined
  resultPreview?: MapSearchDto[] | undefined
}

export interface MapSearchSuggestionDto {
  suggestion?: string | undefined
  count: number
}

export interface PaginatedListOfMetadataDto {
  items?: MetadataDto[] | undefined
  pageIndex: number
  totalPages: number
  totalCount: number
  hasPreviousPage: boolean
  hasNextPage: boolean
}

export interface MetadataDto {
  id: string
  title?: string | undefined
  pageNumber: number
  pageSection?: string | undefined
  region?: string | undefined
  chapter?: string | undefined
  isDigitalOnly: boolean
}

export interface MetadataDetailDto {
  id: string
  title?: string | undefined
  asset?: AssetDto | undefined
  chapter?: ChapterDto | undefined
  topicChapter?: ChapterDto | undefined
  region?: RegionDto | undefined
  theme?: ThemeDto | undefined
  chapterTheme?: ThemeDto | undefined
  aliasses?: string | undefined
  generatedAliasses?: string | undefined
  pageNumber: number
  pageSection?: string | undefined
  category?: string | undefined
  isDigitalOnly: boolean
  dateOfMap: Date
  attachments?: AttachmentDto[] | undefined
  licences?: LicenceDto[] | undefined
  showUnderChapter: boolean
  showUnderRegion: boolean
}

export interface TopographyMetadataDto {
  id: string
  casperId?: string | undefined
  corner?: LatLng | undefined
  oppositeCorner?: LatLng | undefined
  projection?: string | undefined
}

export interface CreateMetadataCommand {
  licenceIds?: string[] | undefined
  assetId: string
  chapterId?: string | undefined
  topicChapterId?: string | undefined
  regionId?: string | undefined
  themeId?: string | undefined
  title?: string | undefined
  aliasses?: string[] | undefined
  category?: string | undefined
  pageNumber: number
  pageSection?: string | undefined
  isDigitalOnly: boolean
  chapterThemeId?: string | undefined
  showUnderChapter: boolean
  showUnderRegion: boolean
  date: Date
  attachments?: AttachmentDto[] | undefined
}

export interface UpdateMetadataCommand {
  id: string
  licenceIds?: string[] | undefined
  assetId: string
  chapterId?: string | undefined
  topicChapterId?: string | undefined
  regionId?: string | undefined
  themeId?: string | undefined
  title?: string | undefined
  aliasses?: string[] | undefined
  category?: string | undefined
  pageNumber: number
  pageSection?: string | undefined
  isDigitalOnly: boolean
  chapterThemeId?: string | undefined
  showUnderChapter: boolean
  showUnderRegion: boolean
  date: Date
  attachments?: AttachmentDto[] | undefined
}

export interface BosatlasDto {
  projects?: ProjectDto[] | undefined
  projectComparisons?: ProjectComparisonDto[] | undefined
  bundles?: BundleDto[] | undefined
  sharedProjects?: ProjectDto[] | undefined
  sharedComparisons?: ProjectComparisonDto[] | undefined
}

export interface CreateProjectComparisonCommand {
  title?: string | undefined
  projects?: ComparisonProjectDto[] | undefined
  layout: ComparisonLayout
  bundleIds?: string[] | undefined
}

export interface ComparisonProjectDto {
  projectId?: string | undefined
  mapId?: string | undefined
  projectTitle?: string | undefined
  drawing?: string | undefined
}

export interface CopyProjectComparisonCommand {
  comparisonId: string
  title?: string | undefined
  projects?: ComparisonProjectDto[] | undefined
}

export interface ProjectComparisonDetailDto {
  id: string
  profileId: string
  title?: string | undefined
  first?: ProjectComparisonProjectDto | undefined
  second?: ProjectComparisonProjectDto | undefined
  third?: ProjectComparisonProjectDto | undefined
  fourth?: ProjectComparisonProjectDto | undefined
  layout: ComparisonLayout
  history?: string | undefined
  bundles?: BundleDto[] | undefined
}

export interface ProjectComparisonProjectDto {
  id: string
  metadataId: string
  title?: string | undefined
  drawing?: string | undefined
  history?: string | undefined
}

export interface UpdateProjectComparisonCommand {
  id: string
  title?: string | undefined
  projects?: ComparisonProjectDto[] | undefined
  layout: ComparisonLayout
  bundleIds?: string[] | undefined
}

export interface ProjectDetailDto {
  id: string
  profileId: string
  map?: MapDto | undefined
  title?: string | undefined
  drawing?: string | undefined
  bundles?: BundleDto[] | undefined
  attachments?: AttachmentDto[] | undefined
}

export interface CreateProjectCommand {
  metadataId: string
  title?: string | undefined
  drawing?: string | undefined
  bundleIds?: string[] | undefined
  attachments?: AttachmentDto[] | undefined
}

export interface CopyProjectCommand {
  projectId: string
  title?: string | undefined
  drawing?: string | undefined
  bundleIds?: string[] | undefined
}

export interface UpdateProjectCommand {
  projectId: string
  metadataId: string
  title?: string | undefined
  drawings?: string | undefined
  bundleIds?: string[] | undefined
  attachments?: AttachmentDto[] | undefined
}

export interface CreateRegionCommand {
  chapterId: string
  name?: string | undefined
  licenceIds?: string[] | undefined
  order: number
}

export interface PaginatedListOfRegionDto {
  items?: RegionDto[] | undefined
  pageIndex: number
  totalPages: number
  totalCount: number
  hasPreviousPage: boolean
  hasNextPage: boolean
}

export interface RegionDetailDto {
  id: string
  chapterId: string
  chapter?: ChapterDto | undefined
  name?: string | undefined
  licences?: LicenceDto[] | undefined
  order: number
}

export interface UpdateRegionCommand {
  id: string
  chapterId: string
  name?: string | undefined
  licenceIds?: string[] | undefined
  order: number
}

export interface CreateThemeCommand {
  name?: string | undefined
  licenceIds?: string[] | undefined
  order: number
  chapterId?: string | undefined
  regionId?: string | undefined
}

export interface PaginatedListOfThemeOverviewDto {
  items?: ThemeOverviewDto[] | undefined
  pageIndex: number
  totalPages: number
  totalCount: number
  hasPreviousPage: boolean
  hasNextPage: boolean
}

export interface ThemeOverviewDto {
  id: string
  name?: string | undefined
  parent?: string | undefined
  order: number
}

export interface ThemeDetailDto {
  id: string
  name?: string | undefined
  licences?: LicenceDto[] | undefined
  chapter?: ChapterDto | undefined
  region?: RegionDto | undefined
  order: number
}

export interface UpdateThemeCommand {
  id: string
  name?: string | undefined
  licenceIds?: string[] | undefined
  order: number
  chapterId?: string | undefined
  regionId?: string | undefined
}

export interface PaginatedListOfTopographyDto {
  items?: TopographyDto[] | undefined
  pageIndex: number
  totalPages: number
  totalCount: number
  hasPreviousPage: boolean
  hasNextPage: boolean
}

export interface TopographyDto {
  id: string
  name?: string | undefined
  suffix?: string | undefined
  page: number
  letter?: string | undefined
  lat?: string | undefined
  lng?: string | undefined
  metadata?: MetadataDto | undefined
  verified: boolean
}

export interface CreateTopographyCommand {
  name?: string | undefined
  page: number
  letter?: string | undefined
  lat?: string | undefined
  lng?: string | undefined
  suffix?: string | undefined
  metadataId?: string | undefined
}

export interface UpdateTopographyCommand {
  id: string
  name?: string | undefined
  page: number
  letter?: string | undefined
  lat?: string | undefined
  lng?: string | undefined
  suffix?: string | undefined
  metadataId?: string | undefined
}

export interface VerifyTopographyCommand {
  id: string
}

export interface LocationLookupResponse {
  response?: GoogleLocationResponse | undefined
  apiCallCount: number
}

export interface GoogleLocationResponse {
  status?: string | undefined
  candidates?: GoogleLocationCandidate[] | undefined
}

export interface GoogleLocationCandidate {
  geometry?: GoogleLocationGeometry | undefined
}

export interface GoogleLocationGeometry {
  location?: GoogleLocationLocation | undefined
  viewport?: GoogleLocationViewport | undefined
}

export interface GoogleLocationLocation {
  lat: number
  lng: number
}

export interface GoogleLocationViewport {
  northeast?: GoogleLocationLocation | undefined
  southwest?: GoogleLocationLocation | undefined
}

export interface UserGroupDto {
  id: string
  name?: string | undefined
  isClass: boolean
}

export interface UserGroupWithStudentsDto {
  id: string
  name?: string | undefined
  students?: UserGroupStudentDto[] | undefined
}

export interface UserGroupStudentDto {
  id: string
  firstName?: string | undefined
  lastName?: string | undefined
}

export interface ShareWithGroupCommand {
  groupIds?: string[] | undefined
  id: string
  type: ShareableTypes
}

export enum ShareableTypes {
  PROJECT = 0,
  COMPARISON = 1
}

export interface ShareWithGroupsOrStudentsCommand {
  groupIds?: string[] | undefined
  studentIds?: string[] | undefined
  projectIds?: string[] | undefined
  comparisonIds?: string[] | undefined
}

export interface FileResponse {
  data: Blob
  status: number
  fileName?: string
  headers?: { [name: string]: any }
}
